import { memo } from 'react'
import { TableRow, TableCell, Typography } from '@mui/material'

function TableEmptyState({ colSpan = 8, message = 'No items found' }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 4, color: '#999' }}>
        <Typography color="text.secondary">{message}</Typography>
      </TableCell>
    </TableRow>
  )
}

export default memo(TableEmptyState)
